module.exports = Object.freeze({
  'res': `{
  "data": [
    {
      "code": "AAPL.PS",
      "metrics": "P/S",
      "value": 7.550273,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.PE",
      "metrics": "P/E",
      "value": 30.826351,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.MKTCAP",
      "metrics": "Market Cap",
      "value": 2907572237520,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.MKTEBT",
      "metrics": "Mkt Cap / EBT",
      "value": 26.023667,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.ROA",
      "metrics": "ROA (%)",
      "value": 27.446813,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.ROE",
      "metrics": "ROE (%)",
      "value": 167.770198,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.CR",
      "metrics": "Curr. Ratio",
      "value": 0.93802,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.TO.REC",
      "metrics": "Rec. T/O",
      "value": 16.315973,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.PER.AVGCOLL",
      "metrics": "Avg. Coll. Days",
      "value": 22.370716,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.DEBT.EQ",
      "metrics": "Debt/Eq.",
      "value": 2.145169,
      "date": "2022-09-30"
    },
    {
      "code": "AAPL.DEBT.RAT",
      "metrics": "Debt %",
      "value": 0.308146,
      "date": "2022-09-30"
    },
    {
      "code": "AAPL.INT.COV",
      "metrics": "Int. Cov.",
      "value": 34.026235,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.LTCAP",
      "metrics": "LT Cap. Rat",
      "value": 0.682052,
      "date": "2022-09-30"
    },
    {
      "code": "AAPL.ASS.SAL",
      "metrics": "Assets/Sales",
      "value": 0.894746,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.SAL.INV",
      "metrics": "Sales/Invy.",
      "value": 56.823607,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.INT.CFOPER",
      "metrics": "Int./Cashflow",
      "value": 34.700617,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.DEBT.CFOPER",
      "metrics": "Debt/Cashflow",
      "value": 1.123744,
      "date": "2022-09-30"
    },
    {
      "code": "AAPL.TO.ASSET",
      "metrics": "Assets T/O",
      "value": 1.117636,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.EBT.MGN",
      "metrics": "EBT Mgn",
      "value": 0.292837,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.PCF",
      "metrics": "P/CF",
      "value": 26.532817,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.REV.TTM",
      "metrics": "Sales",
      "value": 385095000000,
      "date": "2023-03-31"
    },
    {
      "code": "AAPL.REV.TTM",
      "metrics": "Sales",
      "value": 387537000000,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.NETINC.TTM",
      "metrics": "Earnings(TTM)",
      "value": 94321000000,
      "date": "2023-03-31"
    },
    {
      "code": "AAPL.NETINC.TTM",
      "metrics": "Earnings(TTM)",
      "value": 95171000000,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.PCHG|30",
      "metrics": "1M %Chg",
      "value": 0.0708,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.PCHG|180",
      "metrics": "6M %Chg",
      "value": 0.3748,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.PCHG|365",
      "metrics": "1Y Return",
      "value": 0.4261,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.RETURNS|1095",
      "metrics": "3Y Cum. Return",
      "value": 0.2874,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.RETURNS|1825",
      "metrics": "5Y Cum. Return",
      "value": 0.3252,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.RETURNS|3650",
      "metrics": "10Y Cum. Return",
      "value": 0.2999,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.EBT.TTM",
      "metrics": "EBT (TTM)",
      "value": 111728000000,
      "date": "2023-03-31"
    },
    {
      "code": "AAPL.EBT.TTM",
      "metrics": "EBT (TTM)",
      "value": 113485000000,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.ASSETS",
      "metrics": "Assets",
      "value": 332160000000,
      "date": "2023-03-31"
    },
    {
      "code": "AAPL.ASSETS",
      "metrics": "Assets",
      "value": 346747000000,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.LIABS",
      "metrics": "Liabilities",
      "value": 270002000000,
      "date": "2023-03-31"
    },
    {
      "code": "AAPL.LIABS",
      "metrics": "Liabilities",
      "value": 290020000000,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.SEQ",
      "metrics": "Shareholders Equity",
      "value": 62158000000,
      "date": "2023-03-31"
    },
    {
      "code": "AAPL.SEQ",
      "metrics": "Shareholders Equity",
      "value": 56727000000,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.DIV.PS.TTM",
      "metrics": "Dividend/Share (TTM)",
      "value": 0.92,
      "date": "2023-03-31"
    },
    {
      "code": "AAPL.DIV.PS.TTM",
      "metrics": "Dividend/Share (TTM)",
      "value": 0.91,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.CFOPER.TTM",
      "metrics": "Cash From Oper. (TTM)",
      "value": 109584000000,
      "date": "2023-03-31"
    },
    {
      "code": "AAPL.CFOPER.TTM",
      "metrics": "Cash From Oper. (TTM)",
      "value": 109190000000,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.CFFIN.TTM",
      "metrics": "Cash From Fin. (TTM)",
      "value": -115526000000,
      "date": "2023-03-31"
    },
    {
      "code": "AAPL.CFFIN.TTM",
      "metrics": "Cash From Fin. (TTM)",
      "value": -118153000000,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.CFINV.TTM",
      "metrics": "Cash From Inv. (TTM)",
      "value": 3891000000,
      "date": "2023-03-31"
    },
    {
      "code": "AAPL.CFINV.TTM",
      "metrics": "Cash From Inv. (TTM)",
      "value": -7693000000,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.VOL|Y",
      "metrics": "Vol.",
      "value": 0.236,
      "date": "2023-12-31"
    },
    {
      "code": "AAPL.DRAWDN.PROB20|5Y",
      "metrics": "Prob. of 20% Loss",
      "value": 60.77,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.DRAWDN.PROB30|5Y",
      "metrics": "Prob. of 30% Loss",
      "value": 16.92,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.DRAWDN.PROB40|5Y",
      "metrics": "Prob. of 40% Loss",
      "value": 0,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.REV.TTM|PCHG.1Y",
      "metrics": "Rev %, 1Y",
      "value": -0.23885,
      "date": "2023-03-31"
    },
    {
      "code": "AAPL.NETINC.TTM|PCHG.1Y",
      "metrics": "Income %, 1Y",
      "value": -7.469466,
      "date": "2023-03-31"
    },
    {
      "code": "AAPL.FCF",
      "metrics": "FCF",
      "value": 30218000000,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.FCF.TTM",
      "metrics": "FCF (TTM)",
      "value": 97498000000,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.FCF.PS.TTM",
      "metrics": "FCF Per Share (TTM)",
      "value": 6.154242,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.FCF.YIELD",
      "metrics": "FCF Yield",
      "value": 3.352969,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.EBITDA.TTM",
      "metrics": "EBITDA",
      "value": 128048000000,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.EV",
      "metrics": "EV",
      "value": 2882885237520,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.EV.EBITDA",
      "metrics": "EV/EBITDA",
      "value": 22.755249,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.EBIT.TTM",
      "metrics": "EBITDA",
      "value": 116725000000,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.PFCF",
      "metrics": "Price / FCF",
      "value": 29.824313,
      "date": "2023-06-16"
    },
    {
      "code": "AAPL.EBITDA.MGN",
      "metrics": "EBITDA Margin",
      "value": 0.330415,
      "date": "2022-12-31"
    },
    {
      "code": "AAPL.NETINC.MGN",
      "metrics": "Earnings Margin(TTM)",
      "value": 0.245579,
      "date": "2022-12-31"
    }
  ]
}` ,
});
